import { format } from "date-fns";
import { getFullName, getPoBoxAddress } from "utils";

const PopulatedRow = ({ transferee, transferor, transferNumber }) => {
  return (
    <tr className="text-xs">
      <td className="p-1 text-gray-600 bg-gray-100">
        {format(
          new Date(transferee.currentAllottedClass.allotmentDate),
          "dd-MM-yyyy"
        )}
      </td>
      <td className="p-1 text-gray-600 bg-gray-100">{transferNumber}</td>
      <td className="p-1 text-gray-600 bg-gray-100">
        {transferor.memberRegisterFolio}
      </td>
      <td className="p-1 text-gray-600 bg-gray-100">
        {getFullName(transferor.names)}
      </td>
      <td className="p-1 text-gray-600 bg-gray-100">
        {getPoBoxAddress(
          transferor.idType,
          transferor.postalAddress,
          transferor.isNonResident
        )}
      </td>
      <td className="p-1 text-gray-600 bg-gray-100">
        {getFullName(transferee.names)}
      </td>
      <td className="p-1 text-gray-600 bg-gray-100">
        {getPoBoxAddress(
          transferee.idType,
          transferee.postalAddress,
          transferee.isNonResident
        )}
      </td>
      <td className="p-1 text-gray-600 bg-gray-100">
        {transferee.memberRegisterFolio}
      </td>
      <td className="p-1 text-gray-600 bg-gray-100">
        {transferee.currentAllottedClass.classOfShares === "Ordinary Shares"
          ? transferee.currentAllottedClass.allottedShares
          : ""}
      </td>
      <td className="p-1 text-gray-600 bg-gray-100">
        {transferee.currentAllottedClass.classOfShares === "Preference Shares"
          ? transferee.currentAllottedClass.allottedShares
          : ""}
      </td>
      <td className="p-1 text-gray-600 bg-gray-100">
        {transferee.currentAllottedClass.shareStart}
      </td>
      <td className="p-1 text-gray-600 bg-gray-100">
        {transferee.currentAllottedClass.shareEnd}
      </td>
      <td className="p-1 text-gray-600 bg-gray-100">
        {transferee.currentAllottedClass.sharesValue *
          transferee.currentAllottedClass.allottedShares}
      </td>
      <td className="p-1 text-gray-600 bg-gray-100">
        {transferee.currentAllottedClass.shareCertificateNumber}
      </td>
    </tr>
  );
};

export default PopulatedRow;
